import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { NotificationProvider } from '@/app/providers/NotificationProvider'
import { ThemeProvider } from '@/app/providers/ThemeProvider'
import type { User } from '@/features/auth/stores/authStore'
import { PageErrorBoundary } from '@/shared/components/errors/ErrorBoundary'
import { Toaster } from '@/shared/components/ui/sonner'
import { TooltipProvider } from '@/shared/components/ui/tooltip'

interface AuthContext {
  isAuthenticated: boolean
  isLoading: boolean
  user: User | null
  login: (email: string, password: string) => Promise<void>
  logout: () => Promise<void>
}

interface RouterContext {
  auth: AuthContext
}

export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: ({ context }) => {
    // Global auth loading state - this runs before ALL routes
    if (context.auth.isLoading) {
      // Show loading at the root level, don't let any routes process
      return
    }
  },
  component: RootComponent,
})

function RootComponent() {
  return (
    <PageErrorBoundary>
      <ThemeProvider defaultTheme='system' storageKey='coobird-ui-theme'>
        <TooltipProvider>
          <NotificationProvider>
            <Outlet />
            <Toaster />
          </NotificationProvider>
        </TooltipProvider>
      </ThemeProvider>
    </PageErrorBoundary>
  )
}
